// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: '',
  google_client_id: "256917998382-736bnd7fmffq8ulu5lpd3eoaimd0a8iu.apps.googleusercontent.com",
  google_client_secret: "GPwygztVkHjs4IubWavUWG2n",
  help_form_id: "609411fd30b8054f604249b9",
  stripe_publishable_key: "pk_test_51MWvEdSGYnpeGJRDUDVVT3u4oFYIC0kvOIdYSqUg1WiloZod8hugh7E1SVozTvh09Ryp1hGDNPzNaGBDMBahkU9j00FoZqc0wa",
  data_time_timezone: "America/Los_Angeles",
  stripe_url: "https://billing.stripe.com/p/login/aEUbMv0rseIk7fy5kk"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
